export default __webpack_public_path__ + "static/media/auditai3.9fdbe988.png";